// Les documents d'impression (plan de classe, coloriage, fiche séquence) sont
// écrits dans une fenêtre ouverte par window.open('') : ils n'ont pas d'URL
// propre, donc pas de base pour résoudre une URL relative. On leur sert donc
// les fontes du site en absolu, depuis static/fonts/, plutôt que par Google
// Fonts. Les unicode-range viennent de @fontsource-variable/{lora,dm-sans}
// (unicode.json) ; latin-ext reste nécessaire pour les diacritiques du
// français hors du sous-ensemble latin.
const LATIN =
	'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD';
const LATIN_EXT =
	'U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF';

function face(family: string, file: string, weights: string, range: string, origin: string): string {
	return `@font-face{font-family:'${family}';src:url('${origin}/fonts/${file}.woff2') format('woff2');font-weight:${weights};font-style:normal;font-display:swap;unicode-range:${range}}`;
}

/**
 * Bloc @font-face à injecter en tête de la feuille de style d'un document
 * d'impression. `origin` n'est lu qu'à l'appel (jamais à l'import) et reste
 * vide côté serveur : le module doit survivre au prérendu, où `location`
 * n'existe pas.
 */
export function printFontFaces(
	origin: string = typeof location === 'undefined' ? '' : location.origin
): string {
	return [
		face('Lora', 'lora-latin', '400 700', LATIN, origin),
		face('Lora', 'lora-latin-ext', '400 700', LATIN_EXT, origin),
		face('DM Sans', 'dm-sans-latin', '100 1000', LATIN, origin),
		face('DM Sans', 'dm-sans-latin-ext', '100 1000', LATIN_EXT, origin)
	].join('\n');
}
